import App from 'app/App';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { loadConfig } from './config';

import { createRoot } from 'react-dom/client';

loadConfig()
  .then(() => {
    const container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container);

    root.render(
      <Suspense fallback="Loading...">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    );

    serviceWorker.unregister();
  })
  .catch((err) => {
    console.error(err);
    const container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container);

    root.render(<div>Failed to load application configuration.</div>);

    serviceWorker.unregister();
  });
